import { createSlice } from '@reduxjs/toolkit'
import { ScriptState } from './types'
import { fetchUserScripts } from './scriptThunk'

const initialState: ScriptState = {
  data: null,
  loading: false,
  error: null,
}

const scriptSlice = createSlice({
  name: 'script',
  initialState,
  reducers: {
    clearScripts: (state) => {
      state.data = null
      state.error = null
      state.loading = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserScripts.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUserScripts.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchUserScripts.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { clearScripts } = scriptSlice.actions

export default scriptSlice.reducer
